export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-tuv.151fb2e2.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};